import { render, staticRenderFns } from "./die-selection-pro.vue?vue&type=template&id=8ba00b24&scoped=true&"
import script from "./die-selection-pro.vue?vue&type=script&lang=js&"
export * from "./die-selection-pro.vue?vue&type=script&lang=js&"
import style0 from "./die-selection-pro.vue?vue&type=style&index=0&id=8ba00b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba00b24",
  null
  
)

export default component.exports